import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { HERO_IMAGE } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-white" data-id="element-62" data-mp="9k0ep7vr8fpn">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] grid-paper opacity-60" aria-hidden="true" data-id="element-63" data-mp="9ih0rnxkmgr1" />
      <div className="relative mx-auto max-w-4xl px-5 pt-12 text-center sm:pt-16" data-id="element-64" data-mp="12a0lxddqa4vo">
        <motion.span initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 rounded-full border border-sage bg-sage-mist px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-forest" data-id="element-65" data-mp="xae6qyecaek8">
          Sistema Negocio Rentable
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mx-auto mt-5 max-w-3xl text-balance font-display text-[26px] font-extrabold leading-[1.15] tracking-tight text-black sm:text-[44px]" data-id="element-66" data-mp="3cz5u28857tyr">
          <span className="block" data-id="element-67" data-mp="39ala4fa5kq3o">¿Tu negocio gana plata</span>
          <span className="block text-forest" data-id="element-68" data-mp="39a38120t7hnu">o solo cubre costos?</span>
        </motion.h1>
      </div>

      {/* Imagen del producto, sin tapar el título */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className="relative mx-auto mt-6 w-full max-w-3xl px-2 sm:px-5" data-id="element-69" data-mp="30hre366hlc34">
        <img src={HERO_IMAGE} alt="Sistema Negocio Rentable: planillas, calculadoras, dashboard y calendario comercial para emprendedores" className="block w-full" width={1300} height={1300} data-id="element-70" data-mp="2qlof296xltke" />
      </motion.div>

      <div className="relative mx-auto mt-6 max-w-3xl px-5 pb-14 text-center sm:pb-20" data-id="element-71" data-mp="2ljpef72ktar5">
        <p className="mx-auto max-w-lg text-base leading-relaxed text-forest-deep/80 sm:text-lg" data-id="element-72" data-mp="s2bc6ahwz5ay">
          El sistema de gestión para emprendedores que quieren dejar de decidir
          a ciegas: calculá costos, poné precios y controlá tu rentabilidad.
        </p>

        <div className="mt-6 flex items-center justify-center gap-2" data-id="element-73" data-mp="dd5ews2mzp5p">
          <span className="flex" aria-hidden="true" data-id="element-74" data-mp="deyh9v67vn7w">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-olive text-olive" strokeWidth={1.5} data-id="element-75" data-mp="1ayji7gir3k7b" data-mpi={i} />)}
          </span>
          <span className="font-display text-sm font-bold text-forest-deep" data-id="element-76" data-mp="110wqtuk9m06g">
            4.9/5 estrellas
          </span>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-77" data-mp="3lsp3hdsd4jef">
          <CTAButton data-id="element-78" data-mp="3lui70k7oini7" />
        </div>

        <p className="mt-4 text-sm font-semibold text-forest" data-id="element-79" data-mp="3hrd96uyjn9zw">
          🔥 Oferta especial por tiempo limitado
        </p>
      </div>
    </header>;
}